import { useState } from 'react';
import { SaleStatsPage, SaleStatsHeader, SaleStatsBody } from './SaleStatsComponents';
import { RoleGuard } from '../../routes';

export const SaleStats = () => {
  const [totalCount, setTotalCount] = useState(0);

  return (
    <RoleGuard roles={['SUPER_ADMIN']}>
      <SaleStatsPage innerScroll>
        <SaleStatsHeader totalCount={totalCount} />
        <SaleStatsBody setTotalCount={setTotalCount} />
      </SaleStatsPage>
    </RoleGuard>
  );
};
